export default interface StopMediationAbExperimentsRequest {
  variantChoice: VariantChoice;
}
export enum VariantChoice {
  VARIANT_CHOICE_UNSPECIFIED = "VARIANT_CHOICE_UNSPECIFIED",
  VARIANT_CHOICE_A = "VARIANT_CHOICE_A",
  VARIANT_CHOICE_B = "VARIANT_CHOICE_B",
}
